module.exports = __webpack_public_path__ + "static/media/shop1.62957384.png";